export default [
  {
    path: '/invite/:userId/:inviteToken',
    component: () => import('./Invite.vue'),
    name: 'invite'
  }
]
